import { alpha } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  // MAIN CONTENT
  mainTitle: {
    marginBottom: theme.spacing(4),
  },
  paper: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3, 0),
  },
  paragraph: {
    marginBottom: theme.spacing(1),
  },
  mainContainer: {
    maxWidth: 850,
  },

  // FORMS

  section: {
    maxWidth: '642px',
    padding: theme.spacing(4, 0),
  },

  card: {
    minHeight: theme.spacing(45),
  },

  checkbox: {
    display: 'flex',
    padding: theme.spacing(1, 0),
  },

  sectionColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  sectionRowReceptor: {
    display: 'inline-block',
  },

  sectionRowSender: {
    marginRight: '240px',
    display: 'inline-block',
  },
  documentType: {
    '& .MuiSelect-select.MuiSelect-select': {
      display: 'flow !important',
      alignContent: 'center !important',
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
      whiteSpace: 'nowrap !important',
      width: '100% !important', // Asegúrate de que ocupe todo el ancho
    },
  },
  selectOption: {
    '&:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      cursor: 'pointer',
    },
    padding: theme.spacing(1.5),
    color: theme.palette.neutral.light,
    fontWeight: 'bold',
  },
  warning: {
    '& .MuiListItem-root': {
      backgroundColor: theme.palette.warning.light,
    },

    '& .MuiListItemIcon-root svg, .MuiListItemText-secondary': {
      color: theme.palette.warning.darkest,
    },
  },
  smallText: {
    fontSize: '12px',
  },
  row: {
    padding: theme.spacing(4, 0),
    display: 'inline-block',
    width: '100%',
    alignItems: 'start',
    flexDirection: 'column',
  },

  rows: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    rowGap: theme.spacing(2),
  },

  marginInput: {
    marginBottom: theme.spacing(5),
  },

  buttonAddRemove: {
    border: `1px solid ${theme.palette.neutral.light}`,
    marginInline: theme.spacing(2),
    borderRadius: 1000,

    transition: 'border 0.3s',

    '&:hover': {
      border: `1px solid ${theme.palette.primary.light}`,
    },
  },

  marginInput2: {
    marginBottom: theme.spacing(3),
  },

  marginInputLeft: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },

  commoditySelect: {
    width: '77.5%',
  },

  title: {
    marginBottom: theme.spacing(4),
  },
  titleLight: {
    color: theme.palette.neutral.light,
  },
  info: {
    marginBottom: theme.spacing(8),
    lineHeight: 1.43,
    color: theme.palette.neutral.main,
  },
  maginMedium: {
    marginBottom: theme.spacing(4),
  },
  gridContainer: {
    width: 'calc(100% + .75rem)',
    padding: theme.spacing(0.5, 0),

    '& .MuiGrid-item': {
      paddingRight: theme.spacing(1),
    },
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(2),
    '& .MuiInputBase-colorSuccess .MuiInput-input': {
      boxShadow: `0 0 0 100px ${theme.palette.success.light} inset`,
      backgroundColor: theme.palette.success.light,
      borderColor: theme.palette.green.light,
      borderBottomColor: theme.palette.success.dark,
    },
  },
  fieldsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap', // Añadir esta línea
    flexGrow: 'initial',
    minWidth: '100%',
  },
  fieldsRowGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: theme.spacing(2),
    minWidth: '100%',
  },
  fieldXS: {
    flex: '0 0 60px',
  },
  fieldSM: {
    flex: '0 0 175px',
    '& .MuiAutocomplete-input.MuiInput-input.MuiAutocomplete-input:first-of-type':
      {
        paddingRight: theme.spacing(7),
      },
  },
  fieldMD: {
    flex: '1 0 250px',
    '& .MuiAutocomplete-root': {},
  },
  fieldAuto: {
    flex: '1 0 auto',
    '& .MuiAutocomplete-root': {
      width: '100%',
    },
    width: 'min-content',
  },
  linkButtonsContainer: {
    marginTop: theme.spacing(2.25),
    display: 'flex',
    gap: theme.spacing(3),

    '&.without-gap': {
      gap: 0,
    },
  },

  //CUSTOM TEXT
  pointSection: {
    padding: theme.spacing(0, 2, 2),
  },

  textSection: {
    padding: theme.spacing(2, 0, 0),
  },

  // CUSTOM INPUTS
  inputAddress: {
    '& .MuiInputBase-root': {
      width: 468,
    },
  },
  inputComments: {
    '& .MuiInputBase-root': {
      width: 630,
    },
  },
  inputPhone: {
    '& .MuiInputBase-root': {
      width: 163,
    },
  },
  inputEmailInSmallForm: {
    '& .MuiInputBase-root': {
      width: 333,
    },
  },

  fieldPrefixPhone: {
    marginTop: theme.spacing(1.5),
    flex: '1 0 auto',
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiInput-root': {
      marginTop: theme.spacing(0),
    },
  },
  fieldPrefixPhoneSelect: {
    minWidth: '80px !important',
    width: '80px !important',
    '&::before': {
      content: '""',
      position: 'absolute',
      right: theme.spacing(0),
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1px',
      height: '60%',
      backgroundColor: alpha(theme.palette.neutral.lighter, 0.4),
      zIndex: 1,
    },
    '& .MuiInput-input': {
      borderRight: theme.spacing(0),
    },

    '& .MuiAutocomplete-input:first-of-type': {
      padding: '10px !important',
    },
  },
  fieldPrefixPhoneInput: {
    '& .MuiInput-input': {
      borderLeft: theme.spacing(0),
    },
  },

  inputCode: {
    '& .MuiInputBase-root': {
      width: 480,
    },
  },
  inputService: {
    '& .MuiInputBase-root': {
      width: 160,
    },
  },
  inputSelect: {
    width: 525,
  },
  textarea: {
    margin: theme.spacing(1.5, 0, 7),
  },
  optionalLabel: {
    color: theme.palette.neutral.light,
  },

  // STEP 1 ORIGIN
  chip: {
    backgroundColor: theme.palette.neutral.white,
  },

  // ACTION BUTTONS
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(5),
  },

  actionButton: {
    marginLeft: theme.spacing(2),
  },

  // STEP 2 - TO
  newAddressButton: {
    justifyContent: 'right',
    maxWidth: 640,
    marginLeft: 'auto',
    display: 'flex',
    marginBottom: theme.spacing(2),
  },

  addressButtons: {
    display: 'flex',

    '& div:not(:first-of-type)': {
      marginLeft: theme.spacing(3),
    },
  },

  alertStepTwo: {
    marginTop: theme.spacing(2),
  },

  cttExpressPointButtonContained: {
    border: '1px solid #526C0C',
    backgroundColor: '#D2E490',
    color: '#526C0C',
    '&:hover': {
      border: '1px solid #526C0C',
      backgroundColor: '#D2E490',
      color: '#526C0C',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },
  cttExpressPointButtonOutlined: {
    border: '1px solid #E1EDB5',
    color: '#526C0C',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #526C0C',
      color: '#526C0C',
      backgroundColor: 'white',
      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
    },
  },

  // STEP 3 - SHIPMENT
  iconButton: {
    position: 'relative',
    marginRight: theme.spacing(1),
  },
  buttons: {
    marginLeft: 'auto',
    display: 'flex',
    width: 'auto',
  },
  plusIcon: {
    position: 'relative',
    paddingLeft: theme.spacing(3.5),

    '& svg': {
      position: 'absolute',
      left: 0,
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: theme.palette.primary.main,
    },

    '&::after': {
      left: theme.spacing(3.5),
    },

    '&:hover': {
      '&::after': {
        width: `calc(100% - ${theme.spacing(3.5)})`,
      },
    },
  },
  tooltipCenter: {
    alignSelf: 'center',
  },
  buttonGroup: {
    margin: theme.spacing(0),
  },
  paragraphStatement: {
    marginBottom: theme.spacing(4),
    color: theme.palette.neutral.main,
  },
  paragraphStatementWithoutMarginBottom: {
    color: theme.palette.neutral.main,
  },
  sectionKeepInMind: {
    padding: theme.spacing(1.25, 0, 4),
  },
  downloadFormTitle: {
    '&.MuiTypography-h4': {
      marginBottom: 0,
    },
  },

  // STEP 4 - SERVICES
  serviceOptions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 180,

    '& .MuiBox-root': {
      width: '100%',
    },
  },

  // STEP 5 - SUMMARY
  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(4),
  },

  alert: {
    '& + &, & + .MuiButton-root': {
      marginTop: theme.spacing(2),
    },
  },
  alertFitContent: {
    maxWidth: 'fit-content',
  },

  alertLegal: {
    marginBlock: theme.spacing(4),
    marginLeft: 'auto',
    '& *:first-child': {
      marginTop: 0,
    },
    '& *:last-child': {
      marginBottom: 0,
    },
  },

  addressError: {
    color: theme.palette.error.dark,
  },

  helper: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(6),
    color: theme.palette.neutral.light,
  },
  helperLink: {
    marginLeft: theme.spacing(6),
  },
  tooltipBox: {
    width: '100%',
    display: 'flex',
  },
  tooltip: {
    display: 'flex',
    marginLeft: theme.spacing(1),
  },
  emptyTxt: {
    color: theme.palette.neutral.light,
  },
  asteriskTxt: {
    color: theme.palette.neutral.main,
  },
  scheduleInfoItem: {
    '& .MuiTypography-h4': {
      padding: theme.spacing(0),
    },
  },

  // TOOLTIPS
  tooltipInput: {
    position: 'absolute',
    right: 0,
  },

  // TOOLTIPS
  tooltipInputTitle: {
    position: 'absolute',
    marginLeft: 10,
  },

  // ALERTS
  alertEarlyDate: {
    width: '100%',
    maxWidth: 448,
    marginBottom: theme.spacing(2.5),

    '& .MuiTypography-h3medium': { marginBottom: 0 },
  },

  // SUCCESS
  success: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
  },
  successMainContent: {
    margin: theme.spacing(5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  successTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    margin: theme.spacing(3, 0, 1.5),
  },
  successChip: {
    margin: 0,
  },
  successHelperText: {
    width: '100%',
    maxWidth: 320,
  },
  successActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  successPrintButton: {
    marginBottom: theme.spacing(2),
  },
  successDownloadLabelButton: {
    marginBottom: theme.spacing(5),
  },

  // LOADING BUTTON
  loadingButton: {
    '&.Mui-disabled': {
      backgroundColor: 'white',
    },
    '& .MuiLoadingButton-loadingIndicator': {
      color: 'red',
    },
  },

  // ADDRESS BOOK TABLE
  radiosContainer: { margin: theme.spacing(2, 0) },
  radioWrapper: {
    position: 'relative',
    paddingRight: theme.spacing(3),
    maxWidth: '640px',

    alignItems: 'center',
    display: 'flex',

    '&:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      '& $iconButton': {
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'initial',
      },
    },

    '&.is-checked, &:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      '& $chip': {
        backgroundColor: theme.palette.neutral.white,
      },
    },
  },
  radio: {
    padding: theme.spacing(1),
    marginBottom: 0,
    maxWidth: '425px',

    '&:hover .MuiRadio-root': {
      color: theme.palette.primary.main,
    },
  },
}))

export default useStyles
